import {createApp} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import FocusTrap from 'primevue/focustrap';


import '@/assets/styles.scss';
import '@/assets/tailwind.css';
import {definePreset} from "@primevue/themes";


const app = createApp(App)

app.use(createPinia())
app.use(router)


const myPreset = definePreset(Aura,{
    light:{
        root:{
            teste: '#ff0000'
        }
    }
});


app.use(PrimeVue,
    {
        ripple: true,
        theme: {
            preset: myPreset,
            options: {
                darkModeSelector: '.app-dark',
            },

        }
    }
);


app.directive('focustrap', FocusTrap);

app.use(ToastService);
app.use(ConfirmationService);
app.use(DialogService);


app.mount('#app')
